import tw from 'twin.macro';

export const StyledPage = tw.div`flex flex-col justify-between`;
